<template>
  <div class="columns">
    <div class="column">
      <table v-for="(table, table_i) in tables" :key="`TABLE_${table_i}`" :class="`table is-bordered ${table.is_fullwidth ? 'is-fullwidth' : ''}`">
        <tbody>
          
          <tr v-for="(row, row_i) in table.merged_headers" :key="`TABLE_${table_i}_MGD_ROW_${row_i}_DISPLAY`">
            <td v-for="(col, col_i) in row" :colspan="col.cols" :key="`TBL_MGD_HEADERS_DATA_${table_i}_${col_i}_DISPLAY`" :style="`${(col.data.type == 'INPUT') ? 'padding:0px;' : '' }${(col.data && col.data.bg_color) ? 'background:'+col.data.bg_color+';' : '' }${(col.data && col.data.border_color) ? 'border: 2px solid '+col.data.border_color+';' : '' }`">
              <show-custom-layout-object v-if="col.data && col.data.type" v-model="row[col_i].data" :key="`TABLE_${table_i}_MGD_ROW_${row_i}_CLO_${col_i}_COMPONENT`"></show-custom-layout-object>                
            </td>
          </tr>

          <tr v-for="(row, row_i) in table.data" :key="`TABLE_${table_i}_ROW_${row_i}_DISPLAY`">
            <td v-for="(col, col_i) in table.columns" :width="columnWidth({ no_columns : table.columns.length, col })" :key="`TBL_DATA_${table_i}_${col_i}_${col.name}_DISPLAY`" :style="`${(row[col_i] && row[col_i].type == 'INPUT') ? 'padding:0px;' : '' }${(row[col_i] && row[col_i].bg_color) ? 'background:'+((table.is_selectable && local_click_track[`${table_i}-${row_i}-${col_i}`]) ? '#d8d8d8' : row[col_i].bg_color)+';' : '' }${(row[col_i] && row[col_i].border_color) ? 'border: 2px solid '+row[col_i].border_color+';' : '' }`"
            @click="onTableCellClick([table_i, row_i, col_i])" :class="`${(table.is_selectable) ? 'hover-allow' : ''}`">
              <show-custom-layout-object v-if="row[col_i] && row[col_i].type" v-model="row[col_i]" @input="onTableInputResponse($event, [table_i, row_i, col_i])" :key="`TABLE_${table_i}_ROW_${row_i}_CLO_${col_i}_COMPONENT`"></show-custom-layout-object>                
            </td>
          </tr>
        </tbody>
      </table> 
    </div>
    
  </div>
  
</template>
<script>
import ShowCustomLayoutObject from '@/components/Question/CustomLayout/ShowCustomLayoutObject'
import { mapActions, mapGetters } from 'vuex'
export default {
  props : {
    tables : Array
  },
  components : {
    ShowCustomLayoutObject
  },
  data(){
    return {
      local_click_track : {}
    }
  },
  computed : {
    ...mapGetters(['fetchCurrentAnswer']),
  },
  methods : {
    ...mapActions(['updateCurrentAnswer']),
    columnWidth({no_columns, col}){
      let width
      if(col.width){
        width = `${col.width}`
      }else{
        width = `${100/no_columns}%`
      }

      return width
    },
    onTableInputResponse(val, table_indices_arr){
      let newTables = JSON.parse(JSON.stringify(this.fetchCurrentAnswer.tables))
      newTables.data[table_indices_arr.join("-")] = val;
      this.updateCurrentAnswer({
        key : 'tables', value : newTables
      })
    },
    onTableCellClick(table_indices_arr){
      let key = table_indices_arr.join("-")
      this.$set(this.local_click_track, key, !this.local_click_track[key])

      let newTables = JSON.parse(JSON.stringify(this.fetchCurrentAnswer.tables))
      newTables.clicked[key] = !newTables.clicked[key]
      this.updateCurrentAnswer({
        key : 'tables', value : newTables
      })
    }
  },
}
</script>
<style scoped>
.table{
  border-collapse: separate;
  border-spacing: 1px;
}
/* Added on 19th June 2025 because of the issue with the table cells not being aligned properly. Single digit were coming on top and rest in bottom. Height was also too much. */
.table td {
  vertical-align: middle;
  text-align: center;
  height: auto;
  min-height: 40px;
}

.table td:not([style*="padding:0px"]) {
  padding: 2px;
}
</style>